module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K26D92B.7867ed0e.jpg";